import { sendKarteEvent } from '@/utils/karte'

export type FaqPathType = 'top' | 'category' | 'answer'

export type ParsedFaqPath =
  | { type: 'top' }
  | { type: 'category'; categoryId: string }
  | { type: 'answer'; categoryId: string; faqId: string }

/** CMS プレビュー等、業務カテゴリとして計測しない FAQ 配下パス */
const EXCLUDED_FAQ_SEGMENTS = new Set(['draft'])

export function parseFaqPath(pathname: string): ParsedFaqPath | null {
  if (!pathname.startsWith('/faq')) return null

  const normalized = pathname.replace(/\/$/, '') || '/faq'
  if (normalized === '/faq') return { type: 'top' }

  const segments = normalized.split('/').filter(Boolean)
  if (segments[0] !== 'faq') return null

  if (segments.length === 2) {
    if (EXCLUDED_FAQ_SEGMENTS.has(segments[1])) return null
    return { type: 'category', categoryId: segments[1] }
  }

  if (segments.length === 3) {
    if (EXCLUDED_FAQ_SEGMENTS.has(segments[1])) return null
    return {
      type: 'answer',
      categoryId: segments[1],
      faqId: segments[2],
    }
  }

  return null
}

function hasSearchQuery(search: string): boolean {
  if (!search) return false
  const params = new URLSearchParams(search)
  const q = params.get('q')
  return q !== null && q !== ''
}

export function trackFaqPageView(pathname: string, search: string): void {
  const parsed = parseFaqPath(pathname)
  if (!parsed) return

  const pagePath = pathname + search

  switch (parsed.type) {
    case 'top':
      sendKarteEvent('faq_page_view', {
        page_path: pagePath,
        has_search_query: hasSearchQuery(search),
      })
      break
    case 'category':
      sendKarteEvent('faq_category_view', {
        category_id: parsed.categoryId,
        page_path: pagePath,
      })
      break
    case 'answer':
      sendKarteEvent('faq_answer_view', {
        category_id: parsed.categoryId,
        faq_id: parsed.faqId,
        page_path: pagePath,
      })
      break
  }
}
